// extracted by mini-css-extract-plugin
module.exports = {"container":"Dialog_container_1Yp50","overlay":"Dialog_overlay_ZlNg5"};